import React from 'react';

import {KYC_SECTIONS_META} from 'ducks/bookings';

import classNames from 'classnames';

import './styles.css';

const SidebarSection = ({sectionType, clickHandler, icon, className}) => (
  <div
    className={classNames(className, 'SidebarSection')}
    onClick={() => clickHandler(sectionType)}>
    <img src={icon} alt={KYC_SECTIONS_META[sectionType].SIDEBAR_HEADING} />
    <span>{KYC_SECTIONS_META[sectionType].SIDEBAR_HEADING}</span>
  </div>
);

export default SidebarSection;
